import { commercialsStore } from "../stores/commercials.store";

class CommercialsService {
  private static service: CommercialsService;

  static get(): CommercialsService {
    if (!this.service) {
      this.service = new CommercialsService();
    }
    return this.service;
  }

  public get menus(): Array<any> {
    return commercialsStore.menus;
  }

  public get individualMenus(): Array<any> {
    return commercialsStore.individualMenus;
  }

  public get forAllGuestsMenus(): Array<any> {
    return commercialsStore.forAllGuestsMenus;
  }

  public get offers(): Array<any> {
    return commercialsStore.offers;
  }

  public get events(): Array<any> {
    return commercialsStore.events;
  }

  public hasMenus(): boolean {
    return !!this.menus.length;
  }

  public hasOffers(): boolean {
    return !!this.offers.length;
  }

  public hasEvents(): boolean {
    return !!this.events.length;
  }

  public hasCommercials(): boolean {
    return this.hasMenus() || this.hasOffers() || this.hasEvents();
  }

  public availableCommercials(): {
    hasEvents: boolean;
    hasOffers: boolean;
    hasMenus: boolean;
  } {
    return {
      hasEvents: this.hasEvents(),
      hasOffers: this.hasOffers(),
      hasMenus: this.hasMenus(),
    };
  }
}

export default CommercialsService.get();
